module.exports = __webpack_public_path__ + "static/media/title_bg_1.80024c04.svg";